import { AnimatePresence, motion, useInView } from 'framer-motion';
import { ChevronLeft, ChevronRight, ExternalLink, Filter, Github, X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import am from '../assets/apimovie.png';
import bpt from '../assets/berg.png';
import ci from '../assets/ci4.png';
import cd from '../assets/codecamp.png';
import cssa from '../assets/Coffeeshop_Anlyz.png';
import lh from '../assets/linkhub.png';
import lp from '../assets/loanperformance.png';
import oht from '../assets/orangeHRM.png';
import pv from '../assets/petventory.png';
import pc from '../assets/poly.png';
import rm from '../assets/rajawali.png';
import sl from '../assets/schedulink.png';
import sp from '../assets/selfpor.png';

import {
  SiBootstrap,
  SiCodeigniter,
  SiCss3,
  SiGit,
  SiGithub,
  SiGooglesheets,
  SiGoogleslides,
  SiHtml5,
  SiJavascript,
  SiLaravel,
  SiLinkedin,
  SiMysql,
  SiNetlify,
  SiNextdotjs,
  SiNotion,
  SiPhp,
  SiPostgresql,
  SiPrisma,
  SiReact,
  SiTableau,
  SiTailwindcss,
  SiTypescript,
  SiVercel
} from 'react-icons/si';

const projects = [
  {
    title: 'OrangeHRM Automation Testing with Cypress',
    img: oht,
    description: 'Implemented end-to-end test automation for OrangeHRM using Cypress, creating robust test scripts to validate core HR functionalities, enhancing test coverage, and ensuring software reliability through continuous integration.',
    tech: [ <img
      key="cypress"
      src="https://cdn.brandfetch.io/idIq_kF0rb/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B"
      alt="cypress"
      className="w-4 h-4"
    />, <SiLinkedin key="linkedin" />, <SiJavascript key="javascript" />, <SiGithub key="github" />],
    live: 'https://youtu.be/SH8OkHofpQE?si=osb32Var0V5zPZuM',
    github: 'https://github.com/hugowrtma/QA-Engineer-Final-Project',
    category: 'course project',
  },
  {
    title: 'Loan Performance Dashboard',
    img: lp,
    description: 'Created an interactive Power BI dashboard during the Training Software Statistika at Universitas Diponegoro to analyze loan transactions, highlight customer trends, and provide actionable insights.',
    tech: [ <img 
      key="powerbi" 
      src="https://images.squarespace-cdn.com/content/v1/55314942e4b0fc1dd672a975/1619208039692-SVCOG2U74IPHQ353I345/NEW+Power+BI+Logo.png" 
      alt="Power BI" 
      className="w-4 h-4" 
    />, <SiLinkedin key="linkedin" />, <SiGooglesheets key="google-sheets" />],
    live: 'https://www.linkedin.com/posts/hugowrtma_datavisualization-dashboard-powerbi-activity-7369238827376259076-tFdr?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEYDvc4BTqMECFtZYCu014jBR89B7K13oR8',
    github: '',
    category: 'case studies',
  },
  {
    title: 'To-Do List App',
    img: cd,
    description: 'Developed a simple To-Do List app with CRUD functionality during RevoU mini course.',
    tech: [<SiHtml5 key="html" />, <SiCss3 key="css" />, <SiJavascript key="javascript" />, <SiGithub key="github" />],
    live: 'https://revou-coding-camp.github.io/codingcamp-04-aug-25-hugowrtma/',
    github: 'https://github.com/Revou-Coding-Camp/codingcamp-04-aug-25-hugowrtma',
    category: 'course project',
  },
  {
    title: 'Coffee Shop Sales Dashboard',
    img: cssa,
    description: 'Created a sales analysis for a 3-branch NYC coffee shop during the RevoU Mini Course using Excel and Tableau to understand customers and improve operations.',
    tech: [<SiTableau key="tableau" />, <SiNotion key="notion" />, <SiGoogleslides key="google-slides" />, <SiGooglesheets key="google-sheets" />],
    live: 'https://crystalline-process-b56.notion.site/Coffee-Shop-Sales-Analysis-24f3ebd5f49e802ba228f47cc1cf0b8d',
    github: '',
    category: 'case studies',
  },
  {
    title: 'Trip Planner',
    img: bpt,
    description: 'Digital presentation event trip planner.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiVercel key="vercel" />, <SiGit key="git" />],
    live: 'https://berg-puntang-trip.vercel.app',
    github: 'https://github.com/hugowrtma/berg-puntang-trip',
    category: 'personal project',
  },
  {
    title: 'Linkhub',
    img: lh,
    description: 'My personalized digital hub, a custom-built Linktree alternative.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiVercel key="vercel" />, <SiGit key="git" />],
    live: 'https://linkhub-hugo.vercel.app',
    github: 'https://github.com/hugowrtma/Linkhub',
    category: 'personal project',
  },
  {
    title: 'Petventory',
    img: pv,
    description: 'Petventory is a simple and efficient platform for managing your pet inventory. Easily track, add, update, and delete.',
    tech: [<SiNextdotjs key="next.js" />, <SiTailwindcss key="tailwindcss" />, <SiTypescript key="typescript" />, <SiPrisma key="prisma" />, <SiPostgresql key="postgresql" />, <SiGit key="git" />],
    live: 'https://petventory.vercel.app',
    github: 'https://github.com/hugowrtma/petventory',
    category: 'personal project',
  },
  {
    title: 'Self Portofolio',
    img: sp,
    description: 'My portofolio website.',
    tech: [<SiReact key="react.js" />, <SiTailwindcss key="tailwindcss" />, <SiJavascript key="javascript" />, <SiNetlify key="netlify" />, <SiGit key="git" />],
    live: 'https://hugowrtma.site',
    github: 'https://github.com/hugowrtma/self-portofolio',
    category: 'personal project',
  },
  {
    title: 'Schedulink',
    img: sl,
    description: 'Scheduling optimization using Ant Colony Algorithm in Laravel - Final University Project.',
    tech: [<SiLaravel key="laravel" />, <SiPhp key="php" />, <SiJavascript key="javascript" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/CourseSchedulling',
    category: 'coursework project',
  },
  {
    title: 'Rajawali Merah',
    img: rm,
    description: 'E-commerce built with HTML, CSS, JS, MySQL, and PHP.',
    tech: [<SiHtml5 key="html" />, <SiCss3 key="css" />, <SiJavascript key="js" />, <SiMysql key="mysql" />, <SiPhp key="php" />, <SiGit key="git" />],
    live: '#',
    github: '#',
    category: 'team project',
  },
  {
    title: 'Polyclinic Appointment',
    img: pc,
    description: 'Polyclinic management system with CRUD features.',
    tech: [<SiPhp key="php" />, <SiBootstrap key="bootstrap" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/PolyCRUD',
    category: 'coursework project',
  },
  {
    title: 'Shop Us',
    img: ci,
    description: 'E-commerce using CodeIgniter 4 with RBAC and cart.',
    tech: [<SiCodeigniter key="ci4" />, <SiPhp key="php" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/ProjectCi4',
    category: 'coursework project',
  },
  {
    title: 'Hugo Movie',
    img: am,
    description: 'A simple movie search engine using API',
    tech: [<SiHtml5 key="html" />, <SiCss3 key="css" />, <SiJavascript key="javascript" />, <SiGit key="git" />],
    live: '#',
    github: 'https://github.com/hugowrtma/API',
    category: 'coursework project',
  },
];

const categories = [
  'all',
  'personal project',
  'team project',
  'freelance project',
  'course project',
  'coursework project',
  'case studies'
];

const RecentWorks = () => {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.2 });

  const [selectedProject, setSelectedProject] = useState(null);
  const [filter, setFilter] = useState('all');
  const [filterOpen, setFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Get items per page based on screen size
  const getItemsPerPage = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 768) return 2; // Mobile: show only 2 projects
      if (window.innerWidth < 1024) return 4; // Tablet: 2x2 grid  
      return 6; // Desktop: 3x2 grid
    }
    return 6;
  };
  
  const [currentItemsPerPage, setCurrentItemsPerPage] = useState(getItemsPerPage());

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.filter-dropdown')) {
        setFilterOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Handle responsive items per page
  useEffect(() => {
    const handleResize = () => {
      const newItemsPerPage = getItemsPerPage();
      if (newItemsPerPage !== currentItemsPerPage) {
        setCurrentItemsPerPage(newItemsPerPage);
        setCurrentPage(1); // Reset to first page when changing items per page
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [currentItemsPerPage]);

  // Reset current page when filter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  // Lock scroll ONLY when detail modal is open
  useEffect(() => {
    if (selectedProject) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedProject]);

  // close modal with Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setSelectedProject(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(p => p.category === filter);

  // Calculate pagination
  const totalPages = Math.ceil(filteredProjects.length / currentItemsPerPage);
  const startIndex = (currentPage - 1) * currentItemsPerPage;
  const endIndex = startIndex + currentItemsPerPage;
  const displayedProjects = filteredProjects.slice(startIndex, endIndex);

  // Navigation functions with infinity loop
  const goToNextPage = () => {
    setCurrentPage(prev => prev >= totalPages ? 1 : prev + 1);
  };

  const goToPrevPage = () => {
    setCurrentPage(prev => prev <= 1 ? totalPages : prev - 1);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  // Create placeholder items to maintain consistent layout
  const placeholderCount = Math.max(0, currentItemsPerPage - displayedProjects.length);
  const placeholderItems = Array.from({ length: placeholderCount }, (_, index) => ({
    id: `placeholder-${index}`,
    isPlaceholder: true
  }));

  return (
    <section
      id="recent-works"
      className="relative min-h-screen px-6 py-20 overflow-hidden text-white bg-gradient-to-tr from-gray-900 via-slate-900 to-gray-900"
    >
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bg-blue-500 rounded-full top-20 left-20 w-72 h-72 blur-3xl" />
        <div className="absolute bg-purple-500 rounded-full bottom-20 right-20 w-96 h-96 blur-3xl" />
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-grid-pattern bg-grid opacity-[0.02]" />

      <div className="relative z-10 mx-auto max-w-7xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -30 }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="text-4xl font-bold text-transparent md:text-5xl bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 bg-clip-text">
            Recent Works
          </h2>
        </motion.div>

        {/* Controls */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap items-center justify-between gap-4 mb-12"
        >
          <div className="flex items-center gap-4">
            {/* Filter Dropdown */}
            <div className="relative filter-dropdown">
              <motion.button
                onClick={() => setFilterOpen(!filterOpen)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-2 px-6 py-3 border bg-gray-800/50 hover:bg-gray-700/50 rounded-xl border-gray-600/50 backdrop-blur-sm"
              >
                <Filter className="w-4 h-4" />
                <span className="capitalize">{filter === 'all' ? 'All Projects' : filter}</span>
              </motion.button>

              <AnimatePresence>
                {filterOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -10, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -10, scale: 0.95 }}
                    className="absolute left-0 z-20 w-56 mt-2 border shadow-xl top-full bg-gray-800/90 backdrop-blur-lg rounded-xl border-gray-600/50"
                  >
                    {categories.map((cat) => (
                      <button
                        key={cat}
                        onClick={() => {
                          setFilter(cat);
                          setFilterOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-3 hover:bg-gray-700/50 first:rounded-t-xl last:rounded-b-xl ${
                          filter === cat ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300'
                        }`}
                      >
                        <span className="capitalize">{cat === 'all' ? 'All Projects' : cat}</span>
                      </button>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>

          {/* Pagination Info */}
          <div className="text-sm text-gray-400">
            Page {currentPage} of {totalPages} • {filteredProjects.length} projects
          </div>
        </motion.div>

        {/* Projects Grid with Navigation */}
        <div className="flex items-center gap-8">
          {/* Projects Grid Container */}
          <div className="flex-1">
            <motion.div
              ref={containerRef}
              variants={containerVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              key={`${filter}-${currentPage}`}
              className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
            >
              {/* Real Projects */}
              {displayedProjects.map((project, index) => (
                <motion.div
                  key={`${project.title}-${startIndex + index}`}
                  variants={itemVariants}
                  whileHover={{ y: -10, scale: 1.02 }}
                  className="relative overflow-hidden bg-gray-900 border cursor-pointer group rounded-2xl border-gray-700/50"
                  onClick={() => setSelectedProject(project)}
                >
                  {/* Project Image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={project.img}
                      alt={project.title}
                      className="object-cover w-full h-64"
                    />

                    {/* Category Badge */}
                    <div className="absolute px-3 py-1 text-xs text-blue-400 border rounded-lg top-4 left-4 bg-blue-600/20 border-blue-500/30">
                      {project.category}
                    </div>

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-40 group-hover:opacity-100" />
                  </div>

                  {/* Project Info */}
                  <div className="p-6">
                    <h3 className="mb-2 text-xl font-semibold group-hover:text-blue-400">
                      {project.title}
                    </h3>
                    <p className="mb-4 text-sm text-gray-400 line-clamp-2">
                      {project.description}
                    </p>

                    {/* Tech Stack */}
                    <div className="flex flex-wrap gap-2">
                      {project.tech.map((tech, i) => (
                        <span
                          key={i}
                          className="px-3 py-1 text-xs text-gray-300 rounded-full bg-gray-700/50"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              ))}
              
              {/* Placeholder Cards for consistent layout */}
              {placeholderItems.map((placeholder) => (
                <motion.div
                  key={placeholder.id}
                  variants={itemVariants}
                  className="invisible"
                >
                  <div className="h-full overflow-hidden bg-gray-900 border rounded-2xl border-gray-700/50">
                    {/* Placeholder Image */}
                    <div className="h-64 bg-gray-800"></div>
                    {/* Placeholder Info */}
                    <div className="p-6">
                      <div className="h-6 mb-2 bg-gray-800 rounded"></div>
                      <div className="h-10 mb-4 bg-gray-800 rounded"></div>
                      <div className="flex gap-2">
                        <div className="w-16 h-6 bg-gray-800 rounded-full"></div>
                        <div className="w-20 h-6 bg-gray-800 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        {/* Pagination with Navigation */}
        {totalPages > 1 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="flex items-center justify-center gap-4 mt-12"
          >
            {/* Left Navigation Button */}
            <motion.button
              onClick={goToPrevPage}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="p-3 border rounded-full bg-gray-800/80 hover:bg-gray-700/80 border-gray-600/50 backdrop-blur-sm"
            >
              <ChevronLeft className="w-5 h-5 text-blue-400 hover:text-blue-300" />
            </motion.button>

            {/* Pagination Dots */}
            <div className="flex items-center gap-3">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <motion.button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  className={`w-3 h-3 rounded-full ${
                    currentPage === page
                      ? 'bg-blue-500 scale-125'
                      : 'bg-gray-600 hover:bg-gray-500'
                  }`}
                />
              ))}
            </div>

            {/* Right Navigation Button */}
            <motion.button
              onClick={goToNextPage}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="p-3 border rounded-full bg-gray-800/80 hover:bg-gray-700/80 border-gray-600/50 backdrop-blur-sm"
            >
              <ChevronRight className="w-5 h-5 text-blue-400 hover:text-blue-300" />
            </motion.button>
          </motion.div>
        )}
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            className="fixed inset-0 z-[110] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedProject(null)}
          >
            <motion.div
              className="bg-gray-800/95 backdrop-blur-lg rounded-2xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-gray-700/50 relative"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedProject(null)}
                className="absolute p-2 text-gray-400 rounded-full top-4 right-4 hover:text-white hover:bg-gray-700/50"
                aria-label="Close project detail"
              >
                <X className="w-5 h-5" />
              </button>

              <div className="mb-6">
                <img
                  src={selectedProject.img}
                  alt={selectedProject.title}
                  className="object-cover w-full h-64 mb-6 rounded-xl"
                />

                <h3 className="mb-4 text-3xl font-bold text-transparent bg-gradient-to-r from-white to-gray-300 bg-clip-text">
                  {selectedProject.title}
                </h3>

                <div className="flex items-center gap-4 mb-6">
                  <span className="px-3 py-1 text-sm text-blue-400 rounded-full bg-blue-600/20">
                    {selectedProject.category}
                  </span>

                  <div className="flex gap-3">
                    {selectedProject.github && selectedProject.github !== '' && (
                      <a
                        href={selectedProject.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50"
                      >
                        <Github className="w-5 h-5" />
                      </a>
                    )}
                    {selectedProject.live && selectedProject.live !== '#' && (
                      <a
                        href={selectedProject.live}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50"
                      >
                        <ExternalLink className="w-5 h-5" />
                      </a>
                    )}
                  </div>
                </div>

                <p className="mb-6 text-lg leading-relaxed text-gray-300">
                  {selectedProject.description}
                </p>

                <div>
                  <h4 className="mb-3 text-lg font-semibold text-blue-400">Technologies Used</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedProject.tech.map((tech, i) => (
                      <span
                        key={i}
                        className="px-4 py-2 text-sm text-gray-300 rounded-lg bg-gray-700/50"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default RecentWorks;